/**
 * The display label for a model.
 *
 * Model names carry their version and changelog after a dash — "Thales (HO
 * FP) — S14 Agentic v0.48 (M&A history backfill…)" — so a directory shows
 * everything before the first dash and keeps the full string on hover.
 */
export const shortModelName = (name: string | null, id: string): string => {
  if (!name) return id
  const [head] = name.split(/\s+[—–-]\s+/)
  return head.trim() || id
}

/** A Bloomberg-style ticker: a code and a two-letter exchange, "HO FP". */
const TICKER_IN_NAME = /\(([A-Z0-9.]{1,12} [A-Z]{2})\)/

/**
 * The model's ticker.
 *
 * `instrument` is the real source and wins whenever yantra carries one.
 * Until then it is null on every published model, so the ticker is read
 * back out of the name — but only when it has the shape of a ticker, so a
 * name with ordinary parentheses yields nothing rather than a guess.
 * Delete this fallback once `instrument` is populated upstream.
 */
const YIELD_KEY = /\s+(Equity|Index|Comdty|Curncy|Corp|Govt|Mtge|Pfd)$/i

export const modelTicker = (instrument: string | null, name: string | null): string | null => {
  // "ASML NA Equity" reads as "ASML NA" in a column: the yield key is the same
  // word on every row, so it costs width and carries no signal. The full
  // string stays searchable.
  if (instrument) return instrument.replace(YIELD_KEY, "")
  const match = name?.match(TICKER_IN_NAME)
  return match ? match[1] : null
}
